import Lottie from 'react-lottie';
import { Col, Section, Row } from '@guestyci/foundation/Layout';
import TextField from '@guestyci/foundation/TextField';
import createStyles from '@guestyci/foundation/createStyles';
import { Breakpoints } from '@guestyci/foundation/Layout/types';
import defaultTheme from '@guestyci/foundation/theme/defaultTheme';
import mediaBreak from 'app/shareable/theme/breakpoints';
import logoSrc from 'assets/icons/logo/gfh-logo.svg';
import animationSource from 'assets/lottie/host_home_hero.json';

const useStyles = createStyles((theme: typeof defaultTheme) => {
  return {
    root: {
      backgroundColor: theme.palette.background.white,
      padding: '0!important',
      alignItems: 'stretch',
      '& > div[role="presentation"]': {
        minHeight: '100vh',
      },
    },
    mainColumn: {
      padding: '3.7rem 4.8rem',
      minHeight: '100vh',
    },
    imageBg: {
      backgroundColor: theme.palette.primary.hover,
      padding: '1rem',
      display: 'flex',
      flexDirection: 'column',
      placeContent: 'center',
      [mediaBreak.max.sm]: {
        display: 'none',
      },
    },
    captureText: {
      fontSize: '2.5rem',
      lineHeight: 1.4,
      fontWeight: 100,
      padding: '0 1rem',
      marginTop: '1.625rem',
    },
    logoImg: {
      maxWidth: 128,
      width: '100%',
    },
    iframe: {
      height: '100% !important',
      border: 'none',
    },
    iframeBg: {
      padding: '0px',
      background: 'none',
    },
  };
});

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationSource,
};

const breakpoints = {
  sm: 12,
  md: 8,
} as Breakpoints;

interface ILayoutProps {
  children: React.ReactNode;
  captureText?: string;
  iframeUrl?: string | null;
}

export default function Layout({
  children,
  captureText,
  iframeUrl,
}: ILayoutProps) {
  const classes = useStyles();

  return (
    <Section className={classes.root}>
      <Col breakpoints={breakpoints} className={classes.mainColumn}>
        <Row>
          <a href="https://hosts.guesty.com/">
            <img src={logoSrc} alt="Guesty logo" className={classes.logoImg} />
          </a>
        </Row>
        <Row justify="center" align="center" className="flex-grow-1">
          {children}
        </Row>
      </Col>
      <Col
        span={4}
        className={`${classes.imageBg} ${iframeUrl && classes.iframeBg}`}
      >
        {iframeUrl ? (
          <iframe
            className={classes.iframe}
            src={iframeUrl}
            title="Guesty Marketing Material"
          />
        ) : (
          <>
            <div>
              <Lottie options={defaultOptions} />
            </div>
            <TextField
              className={classes.captureText}
              align="center"
              color="white"
            >
              {captureText}
            </TextField>
          </>
        )}
      </Col>
    </Section>
  );
}
